import {Occupancy} from "@variocube/app-api";
import {
    BackButton,
    CodeDigits0,
    CodeForm,
    EnglishKeyboardLayout,
    useBoxes,
    usePlatform,
    useStorageItemValue,
    View,
    ViewContent,
    ViewHeader,
    ViewHeaderItem,
    ViewTitle
} from "@variocube/cube-ui";
import * as React from "react";
import {useMemo} from "react";
import {stylesheet} from "typestyle";
import {Delivery, DeliveryState, PickupEvent, Recipient, Tenant, TenantUser} from "./types";
import {useLocalization} from "../i18n";

interface CodeDialogProps {
    onClose: () => void;
    onVerify: (code: string) => Promise<void>;
}

export function CodeDialog({onClose, onVerify}: CodeDialogProps) {
    const {t} = useLocalization();
    const deliveries = useStorageItemValue<Delivery[]>("deliveries");

    const input = useMemo(() => {
        if (deliveries?.find(delivery => /[a-z]/i.test(delivery.storage.storageCode ?? ""))) {
            return {
                type: "keyboard",
                layout: EnglishKeyboardLayout,
            } as const;
        }
        if (deliveries?.find(delivery => /0/.test(delivery.storage.storageCode ?? ""))) {
            return {
                type: "keypad",
                digits: CodeDigits0,
            } as const;
        }
    }, [deliveries]);

    return (
        <View>
            <ViewHeader>
                <ViewHeaderItem>
                    <BackButton onClick={onClose} label={t("Back")}/>
                </ViewHeaderItem>
                <ViewHeaderItem fill>
                    <ViewTitle>{t("EnterCode")}</ViewTitle>
                </ViewHeaderItem>
            </ViewHeader>
            <ViewContent className={styles.content}>
                <CodeForm
                    className={styles.codeForm}
                    onVerify={onVerify}
                    strings={t}
                    input={input}
                />
            </ViewContent>
        </View>
    );
}

const styles = stylesheet({
    content: {
        display: "flex",
        alignItems: "center",
        justifyContent: "stretch",
    },
    codeForm: {
        flex: 1,
    }
})
